import { render } from "./delete-button.vue?vue&type=template&id=6a703086&ts=true"
import script from "./delete-button.vue?vue&type=script&lang=ts"
export * from "./delete-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__